import React, { FC } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import ContributorDashboardNavigation from '@buyside/components/presentation/ContributorDashboard/contributorDashboardNavigation';
import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import Heading from '@buyside/components/presentation/ContributorDashboard/contributorDashboardHeading';
import MyFundProfiles, {
  fundProfileHeading
} from '@buyside/components/presentation/ContributorDashboard/fundProfile/myFundProfiles';
import MyIdeas from '@buyside/components/presentation/ContributorDashboard/ideas/myIdeas';
import MyPosts, {
  postHeading
} from '@buyside/components/presentation/ContributorDashboard/posts/myPosts';
import MyWhitePapers, {
  whitePaperHeading
} from '@buyside/components/presentation/ContributorDashboard/whitePapers/myWhitePapers';
import ViewerIntroRequestsSent from '@buyside/components/presentation/ContributorDashboard/viewerIntroRequestsSent/ViewerIntroRequestsSent';

import { contributorDashboardUrl } from '@buyside/util/urlHelper';

const NoAccess: React.FC<{ heading: string }> = ({ heading }) => (
  <>
    <Heading title={heading} />
    You do not have access to this item.
  </>
);

const ContributorItemsPageRoot: FC<{ isBuyside: string }> = ({ isBuyside }) => {
  return (
    <ErrorBoundary pageName="contributor dashboard">
      <Router basename={contributorDashboardUrl()}>
        <ContributorDashboardNavigation isBuyside={isBuyside === 'true'} />
        <Routes>
          <Route path="/" element={<Navigate to="/ideas" />} />
          <Route path="/ideas/:ideaId?" element={<MyIdeas />} />
          <Route
            path="/white_papers"
            element={
              isBuyside === 'true' ? <MyWhitePapers /> : <NoAccess heading={whitePaperHeading} />
            }
          />
          <Route
            path="/posts"
            element={isBuyside === 'true' ? <MyPosts /> : <NoAccess heading={postHeading} />}
          />
          <Route
            path="/fund_profile"
            element={
              isBuyside === 'true' ? <MyFundProfiles /> : <NoAccess heading={fundProfileHeading} />
            }
          />
          <Route path="/intro_requests" element={<ViewerIntroRequestsSent />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

export default ContributorItemsPageRoot;
